import PropTypes from 'prop-types'

const YearlyQuartileScoresReport = PropTypes.shape({
  id: PropTypes.string,
  marketIndexes: PropTypes.arrayOf(
    PropTypes.shape({
      date: PropTypes.string,
      value: PropTypes.number
    })
  ),
  quartile: PropTypes.number,
  type: PropTypes.oneOf(['yearly-quartile-scores-reports'])
})

export default YearlyQuartileScoresReport
